/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import SelectInput from "./SelectInput";
import GetItem from "../../../helpers/dataProviders/getItem";
import parseExperienceId from "../../../helpers/routeHelpers/parseExperienceId";
import dateTimeToLocal from "../../../helpers/dateTime/dateTimeToLocal";
import moment from "moment";

class PagePicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			values: [],
		};
		this.experienceId = parseExperienceId();
	}

	componentDidMount() {
		this.getPages();
	}

	getPages = () => {
		let now = moment().utc();
		GetItem(`/experiences/${this.experienceId}/pages`).then(data => {
			let values = [];
			data.data.forEach(page => {
				values.push({
					key: page.id,
					value: page.id,
					label: `${page.name} (${
						page.publishAt
							? now.diff(moment(page.publishAt)) < 0
								? `Will Be Live ${dateTimeToLocal(page.publishAt)}`
								: "Live"
							: "Not Live"
					})`,
				});
			});
			this.setState({ values });
		});
	};

	render() {
		let { values } = this.state;
		return (
			<div className="picker-input">{values.length > 0 && <SelectInput {...this.props} values={values} />}</div>
		);
	}
}

PagePicker.propTypes = {
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	placeholder: PropTypes.string,
	isRequired: PropTypes.bool,
};

export default PagePicker;
